import { useQuery } from "@tanstack/react-query";

import { COMMON_API_ROUTES } from "@/config/apiConfig";
import userAxios from "@/service/axios/userAxios";

// 게시글 목록 조회
export const useGetBoardList = (
    category: string,
    limit: string,
    page: string,
    search: string,
    searchtxt: string,
    options: { enabled: boolean },
) => {
    return useQuery({
        queryKey: ["boardList", category, limit, page],
        queryFn: async () => {
            const res = await userAxios.get(
                `${COMMON_API_ROUTES.BOARD_LIST.replace(":category", category).replace(":limit", limit)}?page=${page}&search=${search}&searchtxt=${searchtxt}&group_id=`,
            );
            return res.data;
        },
        enabled: options.enabled,
    });
};
